
export default function AccountInfo() {
    return (
        <div>
            Please check your email to activate your account
        </div>
    )

}